module.exports = __webpack_public_path__ + "img/edit_black_18dp.902b1275.svg";